module.exports = __webpack_public_path__ + "img/codeImg.c018bfc9.png";